import React from "react";

export default class PropertyStatusDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { task_status, payment_gateway } = this.props.row;

    return (
      <div style={{ color: "darkslategray" }}>
        {this.renderPaymentGateway(payment_gateway)}
        {this.renderTasks(task_status)}
      </div>
    );
  }

  renderPaymentGateway(payment_gateway) {
    var status = "test";
    if (!payment_gateway) {
      status = "na";
    } else if (payment_gateway && payment_gateway.live) {
      status = "live";
    }

    return (
      <div>
        {I18n.t("payments")}:{" "}
        <strong style={{ color: status === "live" ? "green" : "red" }}>
          {I18n.t(status)} {status === "live" ? "✓" : ""}
        </strong>
      </div>
    );
  }

  renderTasks(task_status) {
    const tasks = task_status.tasks.map((task) => {
      return (
        <li key={task.id} title={task.msg}>
          <span
            style={{
              fontSize: "13px",
            }}
          >
            {I18n.t(task.rake_task_name)}: {I18n.t(task.status)}
          </span>
        </li>
      );
    });
    return (
      <div>
        {I18n.t("tasks")}:
        <ul style={{ color: "darkslategray", fontWeight: "normal" }}>
          {tasks}
        </ul>
      </div>
    );
  }
}
